import { render } from "./TheProducts.vue?vue&type=template&id=47c437b2"
import script from "./TheProducts.vue?vue&type=script&lang=js"
export * from "./TheProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__